// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3Gob0","containerItemsCenter":"Skeleton_containerItemsCenter__3SQHv"};